import { ApolloProvider } from '@apollo/client';

interface PublicApolloProviderProps {
  // "Any" due to multiple @apollo/client installations due to transitive peer dependencies (graphql-ws versions differ)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  client: any;
  children: React.ReactNode;
}

/**
 * Exposes an instance of Apollo Client without authentication.
 * This is used for public pages before user authentication,
 * allowing queries that don't require auth (like publicConfig).
 *
 * Note: client is typed as `any` to avoid TypeScript issues with
 * multiple @apollo/client installations in the monorepo caused by
 * transitive peer dependency resolution (graphql-ws versions differ).
 */
export const PublicApolloProvider = ({ client, children }: PublicApolloProviderProps) => {
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
